// extracted by mini-css-extract-plugin
export default {"GridContainer_Fixed":"llWWYgiSMwz2yeLmfbNu","GridContainer_Fluid":"VSDwJOi97afqyB6T0Ccz"};